import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken } from "../../../hooks/useGetData";
import notify from "../../../hook/useNotification";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useNavigate } from "react-router-dom";



//get all users
export const getAllUsers = createAsyncThunk(
    "/usersSlice/users",
    async (query='') => {
        try {
            const response = await useGetDataToken(`/api/v1/users${query}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getAllAdmins = createAsyncThunk(
    "/usersSlice/adminsUsers",
    async (query='') => {
        try {
            const response = await useGetDataToken(`/api/v1/users?isAdmin=true`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const allSupervisorsByCountry = createAsyncThunk(
    "/usersSlice/allSupervisors",
    async (countryID) => {
        try {
            const response = await useGetDataToken(`/api/v1/users?isAdmin=false&liquidation_user=false&is_accountant=false&country=${countryID}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


//add user
export const addOneUser=createAsyncThunk(
    "/usersSlice/addUser",
    async({data})=>{
        try {
            const response=await useInsertData('/api/v1/users', data);
            const navigate = useNavigate();

            
            console.log('res',response);
            // if(response?.errors) 
            // notify(' حدث خطأ اثناء الاضافة حاول مرة اخري','error');
            // else
            notify(" تم اضافة المستخدم بنجاح", "success");
            navigate('/users');
            return response;

        } catch (error) {
           // console.log('uuuuuuuuuuuuuuu',error.response.data);
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else{
            console.log("error?.errors",error);
            if(error.response.data){
                 return notify(error.response.data,"error");
            }
            else{
                return notify(" حدث خطأ اثناء الاضافة من فضلك اكمل البيانات","error");
            }


        }
            
        }
    }
);
//add user
export const blockUsers=createAsyncThunk(
    "/usersSlice/blockUsers",
    async({data})=>{
        try {
            console.log("'/api/v1/blockUsers'," , data)
            // return;
            const response=await useUpdateData('/api/v1/users/usersDisable', data);

            
            console.log('res',response);
            // if(response?.errors) 
            // notify(' حدث خطأ اثناء الاضافة حاول مرة اخري','error');
            // else
            notify("تم تعديل حاله المستخدمين بنجاح", "success");
            return response;

        } catch (error) {
           // console.log('uuuuuuuuuuuuuuu',error.response.data);
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else{
            console.log("error?.errors",error);
            if(error.response.data){
                 return notify(error.response.data,"error");
            }
            else{
                return notify(" حدث خطأ من فضلك حاول مرة اخري","error");
            }


        }
            
        }
    }
);
export const logoutAllUsers=createAsyncThunk(
    "/usersSlice/logoutAllUsers",
    async()=>{
        try {
            console.log("'/api/v1/blockUsers'," , )
            // return;
            const response=await useUpdateData('/api/v1/users/logoutAllUsers');

            
            console.log('res',response);
            // if(response?.errors) 
            // notify(' حدث خطأ اثناء الاضافة حاول مرة اخري','error');
            // else
            notify("تم تعديل حاله المستخدمين بنجاح", "success");
            return response;

        } catch (error) {
           // console.log('uuuuuuuuuuuuuuu',error.response.data);
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else{
            console.log("error?.errors",error);
            if(error.response.data){
                 return notify(error.response.data,"error");
            }
            else{
                return notify(" حدث خطأ من فضلك حاول مرة اخري","error");
            }


        }
            
        }
    }
);

//get one user
export const getOneUser=createAsyncThunk(
    "/usersSlice/getOneUser",
    async({id})=>{
        try {
            const response = await useGetDataToken(`/api/v1/users/${id}`);

            console.log('response',response);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);

//update user
export const updateOneUser=createAsyncThunk(
    "/usersSlice/updateUser",
    async ({ id, data }, { rejectWithValue })=>{
        try {
            const response = await useUpdateData(`/api/v1/users/${id}`, data);
            notify(" تم تعديل المستخدم بنجاح ", "success");
            return response;
            
        } catch (error) {
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else
            return notify(error.response.data,"error");
        }
    }
);

// updateUserProfile
export const updateUserProfile=createAsyncThunk(
    "/usersSlice/updateUserProfile",
    async ({ id, data }, { rejectWithValue })=>{
        try {
            const response = await useUpdateData(`/api/v1/users/${id}`, data);
            notify(" تم تعديل المستخدم بنجاح ", "success");
            return response;
            
        } catch (error) {
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else
            return notify(error.response.data,"error");
        }
    }
);



//get users by city
export const getUsersByCity=createAsyncThunk(
    "/usersSlice/usersByCity",
    async(cityID)=>{
        try {
            const response = await useGetDataToken(`/api/v1/users/userByCity?city=${cityID}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
                return notify(error.response.data,"error");
        }
    }
);
export const getUsersByCountry=createAsyncThunk(
    "/usersSlice/usersByCountry",
    async(countryID)=>{
        try {
            const response = await useGetDataToken(`/api/v1/users/userByCountry?country=${countryID}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
                return notify(error.response.data,"error");
        }
    }
);

//reset users
export const resetUsers=createAsyncThunk(
    "/usersSlice/resetUsers",
    async()=>{
        const users=[];
        return users;
    }
);

//get liquidationUsers
export const getLiquidationUsers=createAsyncThunk(
    "/usersSlice/getLiquidationUsers",
    async()=>{
        try {
            const response = await useGetDataToken(`/api/v1/users`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
                return notify(error.response.data,"error");
        }
    }
);
export const getUserSummary = createAsyncThunk(
    "/usersSlice/usersummary",
    async (query='') => {
        try {
            const response = await useGetDataToken(`/api/v1/home/pref?${query}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);

//get all users
export const getAllUsersWithPagination = createAsyncThunk(
    "/usersSlice/getAllUsersWithPagination",
    async (query='') => {
        try {
            // if(query=='?') return;
            
            const response = await useGetDataToken(`/api/v1/users${query}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);



export const updateOfferComission=createAsyncThunk(
    "/usersSlice/updateOfferComission",
    async ({ id, data }, { rejectWithValue })=>{
        try {
            const response = await useUpdateData(`/api/v1/users/offerCommision/${id}`, data);
            notify(" تم تعديل المستخدم بنجاح ", "success");
            return response;
            
        } catch (error) {
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else
            return notify(error.response.data,"error");
        }
    }
);
